/** Keep the furthest count for one bulk-start run. Queue ticks omit current so they cannot rewind the bar. */
export function mergeBulkStartProgress(prev, incoming) {
  const next = incoming || {};
  // A queue label has no status. Once the run has finished, ignore it so it
  // cannot put the completed bar back into session storage.
  if ((prev?.status === 'completed' || prev?.status === 'cancelled') && !next.status) {
    return prev;
  }
  const same = !!(prev?.operationId && next.operationId && prev.operationId === next.operationId);
  const incomingCurrent = next.current == null || next.current === '' ? null : Number(next.current);
  const incomingTotal = next.total == null || next.total === '' ? null : Number(next.total);
  const current = incomingCurrent == null || Number.isNaN(incomingCurrent)
    ? (prev?.current || 0)
    : (same ? Math.max(prev?.current || 0, incomingCurrent) : incomingCurrent);
  const total = incomingTotal == null || Number.isNaN(incomingTotal)
    ? (prev?.total || 0)
    : (same ? Math.max(prev?.total || 0, incomingTotal) : incomingTotal);
  const takeMax = (field) => {
    if (next[field] == null) return prev?.[field] || 0;
    const value = Number(next[field]) || 0;
    return same ? Math.max(prev?.[field] || 0, value) : value;
  };
  return {
    current,
    total,
    currentAccount: next.currentAccount != null ? next.currentAccount : (prev?.currentAccount || null),
    successCount: takeMax('successCount'),
    failCount: takeMax('failCount'),
    status: next.status || prev?.status || null,
    operationId: next.operationId || prev?.operationId || null,
    timestamp: Date.now(),
  };
}
